module.exports = __webpack_public_path__ + "img/top图.3e4bf58d.png";